import './styles/brand.css';
import './styles/admin.css';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { loadConfig } from './lib/config';
import { bindAuth0ToStore, createAuth0Plugin } from './lib/auth/auth0';

/**
 * 🔴 ORDER: config → pinia → ROUTER → auth0 → mount. The client learned this the hard way: auth0-vue looks
 * for `$router` when it handles the callback, and without one the user lands on `/callback`, signed in, and
 * stays there.
 */
async function bootstrap(): Promise<void> {
  const config = await loadConfig();

  const app = createApp(App);
  app.provide('appConfig', config);
  app.use(createPinia());
  app.use(router);

  if (config.features['auth'] === true) {
    app.use(createAuth0Plugin(config));
    bindAuth0ToStore(app);
  }

  app.mount('#app');
}

void bootstrap().catch((err: unknown) => {
  console.error('[roxxy-admin] bootstrap failed', err);
  const el = document.querySelector('#app');
  if (el) {
    el.textContent = 'Roxxy Admin could not start: configuration is unavailable.';
  }
});
